
var config = {
    development: {
        api: 'https://api.fairfaxcityfutsal.com',
        email: {
            recipient: 'sanmeets@yahoo.com'
        }
    },
    staging: {
        api: 'http://ec2-52-2-104-194.compute-1.amazonaws.com',
        email: {
            recipient: 'sanmeets@yahoo.com'
        }
    },
    production: {
        api: 'https://api.fairfaxcityfutsal.com',
        email: {
            recipient: 'fairfaxcityfutsal@gmail.com; sanmeets@yahoo.com; julio.dejo79@gmail.com'
        }
    }};
    
module.exports = config;